<template>
  <div class="content-container">
    <el-row type="flex" justify="center">
      <el-col :lg="14" :sm="24" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><b>修改密码</b></span>
          </div>
          <el-form ref="passForm" :model="form" :rules="passRules">
            <el-form-item prop="password" required>
              <el-input
                v-model.trim="form.password"
                type="password"
                placeholder="设置密码"
                autocomplete="new-password"
                ><zr-icon slot="prefix" icon="unlock"></zr-icon
              ></el-input>
            </el-form-item>
            <el-form-item prop="password" required>
              <el-input
                v-model.trim="form.confirmPassword"
                type="password"
                placeholder="确认密码"
                autocomplete="new-password"
                ><zr-icon slot="prefix" icon="unlock"></zr-icon
              ></el-input>
            </el-form-item>
          </el-form>
          <el-divider />
          <slot name="footBtn" :form="form">
            <el-button
              icon="el-icon-edit"
              type="primary"
              style="float: right; margin-bottom: 10px"
              @click="modifyPassword"
              >修改密码</el-button
            >
          </slot>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { isEmail, isPassword, isPhone } from "zr-util/src/utils/comm/validate";
import { modifyPassword, resetPassword } from "@api/recruit/user/acl";
import { messageDuration } from "@/config/settings";
import { mapGetters } from "vuex";

export default {
  name: "ModifyPassword",
  data() {
    const validatePassword = (rule, value, callback) => {
      if (!isPassword(value)) {
        callback(new Error("密码不能少于6位"));
      } else {
        callback();
      }
    };
    return {
      form: {},
      passRules: {
        password: [
          { required: true, trigger: "blur", message: "请输入密码" },
          { validator: validatePassword, trigger: "blur" },
        ],
      },
      passwordType: "password",
    };
  },
  computed: {
    ...mapGetters({
      userCode: "user/userCode",
    }),
  },
  methods: {
    modifyPassword() {
      this.$refs["passForm"].validate(async (valid) => {
        if (valid) {
          if (this.form.password !== this.form.confirmPassword) {
            this.$message.warning({
              showClose: true,
              message: "两次密码输入不一致！",
            });
            return;
          }
          const param = {
            userCode: this.userCode,
            password: this.form.password,
          };
          const res = await modifyPassword(param);
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "修改密码成功！",
              duration: messageDuration,
            });
          } else {
            this.$message.error({ showClose: true, message: res.message });
          }
        }
      });
    },
  },
};
</script>

<style scoped></style>
